import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-245e673d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "max-w-5xl mx-auto" };
const _hoisted_2 = { class: "flex flex-col my-1" };
const _hoisted_3 = { class: "flex flex-row my-2" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", { class: "btn btn-red" }, "CSV取込", -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", { class: "btn btn-red" }, "全ユーザ配信", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    const _component_router_link = _resolveComponent("router-link");
    const _component_Form = _resolveComponent("Form");
    const _component_Table = _resolveComponent("Table");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Title, {
            msg: "プッシュ通知履歴",
            submsg: "Release Status"
        }),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                    _createVNode(_component_router_link, {
                        to: "/release-status/csv-import",
                        id: "csv-import",
                        class: "mr-5"
                    }, {
                        default: _withCtx(() => [
                            _hoisted_4
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_router_link, {
                        to: "/release-status/push-all-customer",
                        id: "push-all-customer",
                        class: "mr-5"
                    }, {
                        default: _withCtx(() => [
                            _hoisted_5
                        ]),
                        _: 1
                    })
                ])
            ])
        ]),
        _createVNode(_component_Form, {
            templateTitleList: $data.templateTitleList,
            handleSearch: $options.searchReleasestatus,
            searchedDivisions: $data.searchedDivisions,
            templateFilter: $options.templateFilter
        }, null, 8, ["templateTitleList", "handleSearch", "searchedDivisions", "templateFilter"]),
        _createVNode(_component_Table, {
            searchedReleaseStatuses: $data.searchedReleaseStatuses,
            releaseCancel: $options.releaseCancel,
            getPushDestinations: $options.getPushDestinations,
            getTemplate: $options.getBody
        }, null, 8, ["searchedReleaseStatuses", "releaseCancel", "getPushDestinations", "getTemplate"])
    ]));
}
